const airportLookupInput = document.getElementById('airport-lookup');
const airportLookupResults = document.getElementById('airport-lookup-results');
const airportDropDownList = document.getElementById('book-now-airport-code');

let $url = window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/the-reverie-2021/static/json/airports.json';
/* Filter Scripts */
var oReq = new XMLHttpRequest();
oReq.addEventListener("load", transferComplete);

oReq.open("GET", $url);
oReq.send();

function transferComplete(evt) {
    let completedRequest = JSON.parse(evt.currentTarget.response);
    let rows = completedRequest;

    const isEmpty = str => !str.trim().length;
    // Frequently Searched functionality
    const frequentlySearched = () => {
        collect = [];
        i = 0;
        rows.forEach((row) => {
            for (key in row) {
                if (key == 'favourite' ) {
                    collect[i] = row;
                    i++;
                }
            }
        })
        return collect;
    }
    const populateList = (item) => {
        let elem = document.createElement('li');
        elem.textContent = item.name + '(' + item.iata + ')';
        elem.dataset.value = item.iata;

        elem.addEventListener('click', (e) => {
            document.getElementById('book-now-airport-code').value = e.target.dataset.value;
            document.getElementById('book-now-airport-code').dataset.value = e.target.dataset.value
            document.querySelector('.ui-popup-search').classList.remove('active');
            document.querySelector('.ui-popup-search-overlay').classList.remove('active');
            document.querySelector('.airport-code-origin').classList.remove('z-40');
        });
        return elem; 
    }
    // Event Listener Frequently Search list
    airportDropDownList.addEventListener('click', function (e) {
        document.querySelector('.airport-code-origin').classList.remove('z-40');
        if (!document.querySelector('.airport-code-origin').classList.contains('z-40')) {
            document.querySelector('.airport-code-origin').classList.add('z-40');
        }
        // Check to see if the list exists
        if(airportDropDownList.hasChildNodes) {
            // Add to an array and loop thorugh
            [...airportLookupResults.children].forEach(child => {
                // Add click event on the list items
                child.addEventListener('click', () => {
                    let airportLocation = child.dataset.value;
                    document.getElementById('book-now-airport-code').value = airportLocation;
                    document.getElementById('book-now-airport-code').dataset.value = airportLocation
                    document.querySelector('.ui-popup-search').classList.remove('active');
                    document.querySelector('.ui-popup-search-overlay').classList.remove('active');
                    document.querySelector('.airport-code-origin').classList.remove('z-40');
                });
            });
        }
    });
    // Airport Search functionality
    airportLookupInput.addEventListener('keyup', function (e) { 
        const regex = new RegExp( airportLookupInput.value , 'gi');
        let i = 0;
        let filtered = '';
        let fragment = document.createDocumentFragment();
        // Remove all children related to an element
        if(airportLookupResults.hasChildNodes) {
            [...airportLookupResults.children].forEach(child => {
                airportLookupResults.removeChild(child);
            });
        }
        // If there is any input value
        if(this.value) {
            filtered = rows.filter(item => ((item.name) ? item.name.match(regex) || item.iata.match(regex) : ''));
            // Loop around elements and create them
            // The every command helps return false to stop the loop
            filtered.every((item) => {
                // Add to the fragment
                fragment.appendChild(populateList(item)); 
                i++;
                // If more than 5 results stop
                if(i > 5) {
                    return false;
                }
                return true;
            });
        }
        // If there is NO input value return to Frequently Search list
        if(isEmpty(this.value)) {
            // Create title and append to ol
            let title = document.createElement('h5');
            title.textContent = 'FREQUENTLY SEARCHED';
            title.classList.add('fs-11');
            airportLookupResults.appendChild(title);
            // Loop through items that have favourite: true
            // Add them tot the ol
            frequentlySearched().forEach((item) => {
                fragment.appendChild(populateList(item)); 
            });
        }
        // Append the created fragment
        airportLookupResults.appendChild(fragment);
    });
}

document.querySelectorAll('.ui-popup-initiate').forEach(item => {

    item.addEventListener('click', (e) => {
        let getSib = item.nextElementSibling;

        getSib.querySelector('.ui-popup-search').classList.add('active');
        getSib.querySelector('.ui-popup-search-overlay').classList.add('active');

        document.getElementById('airport-lookup').focus();

        getSib.querySelector('.ui-popup-search-overlay').addEventListener('click', () => {
            getSib.querySelector('.ui-popup-search').classList.remove('active');
            getSib.querySelector('.ui-popup-search-overlay').classList.remove('active');
        });
    });

});